<header>
  <section class="d-flex align-items-center px-3 px-md-5 py-3">
    <div class="logo-container d-flex align-items-center">
      <img src="assets/img/activitypro-logo.png" alt="ActivityPro logo" class="brand-logo-img" />
      <h2 class="m-0 fw-medium">ActivityPro</h2>
    </div>
    <span class="ms-3 fs-6 d-none d-md-inline">An <em><strong>ever-growing</strong></em> platform for clubs across the world</span>
    <div class="header-actions ms-auto d-flex align-items-center gap-3">
      <app-button label="Back to Login" variant="filled" color="primary" routerLink="/auth/login" [fullWidth]="false"
        (clicked)="onBacktoLogin()">
      </app-button>
    </div>
  </section>
</header>

<div class="onboarding-body d-flex justify-content-center p-4">
  <img src="assets/img/bg-pattern.svg" class="bg-icon top-right" alt="" aria-hidden="true">
  <img src="assets/img/bg-pattern.svg" class="bg-icon bottom-left" alt="" aria-hidden="true">
  @if (!isWelcomePage) {
    <div class="left-side d-flex flex-column justify-content-between">
      <div class="stepper-section">
        <app-onboarding-stepper></app-onboarding-stepper>
      </div>
    </div>
  }
  <div class="right-side" [class.full-width]="isWelcomePage">
    <router-outlet></router-outlet>
  </div>
</div>
